/**
 * This file is auto-generated from ChatAttachFileButton.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const attachFiles: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Attach files';
        case 'pl':
            return 'Załącz pliki';
    }
};

export const takePhoto: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Take a photo';
        case 'pl':
            return 'Zrób zdjęcie';
    }
};

export const attachFile: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Attach a file';
        case 'pl':
            return 'Załącz plik';
    }
};

export const attachImage: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Attach an image';
        case 'pl':
            return 'Załącz obraz';
    }
};
